import { Typography } from '@mui/material'
import React from 'react'

/**
 * reactMarkdownComponents is used for the react-markdown Component
 * It maps markdown syntax to our Typography Components insted of normal html tags
 * At the Moment only Headings are included
 */
export const reactMarkdownComponents = {
  h1(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2 }} variant="h1" {...rest} />
  },
  h2(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2 }} variant="h2" {...rest} />
  },
  blockquote(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2 }} variant="h2" {...rest} />
  },
  h3(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 5, mb: 3, color: '#408830' }} variant="h3" {...rest} />
  },
  h4(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 4 }} variant="h4" {...rest} />
  },
  h5(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2 }} variant="h5" {...rest} />
  },
  h6(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2 }} variant="h6" {...rest} />
  },
  p(props: Record<string, unknown>): React.ReactElement {
    const { node, ...rest } = props
    return <Typography sx={{ mt: 2, mb: 2, fontSize: 14 }} {...rest} />
  },
}
